export default __webpack_public_path__ + "static/media/SeaLife_21.26baa3af.png";